import type {
  APIComponentAttributes,
  APIComponentType,
  APIModelAttributes,
  ArdoqId,
} from '@ardoq/api-types';
import { modelOperations } from '@ardoq/core';
import type { WorkspaceAndModelLookup } from '@ardoq/data-model';

export const getWorkspaceModel = (
  workspaceId: ArdoqId,
  { workspacesById, modelsById }: WorkspaceAndModelLookup
): APIModelAttributes | null => {
  const workspace = workspacesById[workspaceId];
  if (!workspace) {
    return null;
  }
  return modelsById[workspace.componentModel] ?? null;
};

export const resolveComponentType = (
  component: APIComponentAttributes,
  workspaceAndModel: WorkspaceAndModelLookup
): APIComponentType | null => {
  const model = getWorkspaceModel(component.rootWorkspace, workspaceAndModel);
  if (!model) {
    return null;
  }
  return (
    modelOperations.getComponentTypes(model).componentTypesById[
      component.typeId
    ] ?? null
  );
};
